<script setup lang="ts">
const localePath = useLocalePath()
const { t } = useI18n()

defineI18nRoute({
  paths: {
    'en-CA': '/unsubscribe-confirmation-page',
    'fr-CA': '/page-confirmation-desabonnement'
  }
})

useHead({
  title: t('navigation.unsubscribeConfirmationPage.metatitle'),
  meta: [{ name: 'description', content: t('navigation.unsubscribeConfirmationPage.metadescription') }],
})

</script>

<template>
  <div class="wrapContent">
    <div class="entetePage">
      <div class="wrapper">
        <div class="filAriane">
          <span class="">
            <NuxtLink :to="localePath('index')">{{ $t('navigation.home.name') }}</NuxtLink>
            <span class=""> &gt; </span>
            <span class="">{{ $t('navigation.unsubscribeConfirmationPage.name') }}</span>
          </span>
        </div>
        <div class="title">
          <h1><span class="">{{ $t('navigation.unsubscribeConfirmationPage.name') }}</span></h1>
        </div>
      </div>
    </div>
    <div class="contentPage">
      <div class="wrapper clearfix">
        <div class="sidebar left">
          <div class="menuCss4">
            <ul class="MenuBar MenuBarActive">
              <li class="item29 selected first last rank0 parent">
                <NuxtLink :to="localePath('unsubscribeConfirmationPage')">
                  <span class="icon">
                    <svg xmlns="http://www.w3.org/2000/svg"
                         viewBox="0 0 320 512">
                      <path d="M137.4 374.6c12.5 12.5 32.8 12.5 45.3 0l128-128c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8L32 192c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l128 128z" />
                    </svg>
                  </span>
                  <span>
                    {{ $t('navigation.unsubscribeConfirmationPage.name') }}
                  </span>
                </NuxtLink>
              </li>
            </ul>
          </div>
        </div>
        <div class="contenu right">
          <div>
            <p>{{ $t('unsubscribeConfirmation.message1') }}</p>
            <p>{{ $t('unsubscribeConfirmation.message2') }}</p>
            <p><strong>{{ $t('unsubscribeConfirmation.message3') }}</strong></p>
            <p v-html="$t('unsubscribeConfirmation.address')"></p>
            <p>{{ $t('unsubscribeConfirmation.phone') }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss"></style>
